var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 529,
    height: 1821,
    viewBox: "0 0 529 1821",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    filter: "url(#filter0_f_2590_13822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-274.759 1537.97L-494.929 1522.16L-561.217 1532.17L-666.676 1548.1C-692.79 1552.04 -772.928 1613.2 -816.116 1619.72C-850.666 1624.94 -892.924 1598.62 -909.735 1584.8C-923.814 1505.17 -952.656 1333.22 -955.385 1282.49C-958.114 1231.76 -858.833 1155.43 -808.851 1123.6C-715.801 1043.64 -521.062 882.427 -486.511 877.21L-244.457 840.659L-142.488 658.765L-105.832 275.643L62.6903 201.138L140.239 238.485L188.739 382.79C202.405 434.739 227.199 544.964 217.052 570.282C206.904 595.599 232.576 711.639 246.681 766.494L298.652 995.01L328.5 1192.68L294.356 1374.73L216.379 1463.81L-11.8998 1523.55L-274.759 1537.97Z",
    fill: "#4B65AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-274.759 1537.97L-494.929 1522.16L-561.217 1532.17L-666.676 1548.1C-692.79 1552.04 -772.928 1613.2 -816.116 1619.72C-850.666 1624.94 -892.924 1598.62 -909.735 1584.8C-923.814 1505.17 -952.656 1333.22 -955.385 1282.49C-958.114 1231.76 -858.833 1155.43 -808.851 1123.6C-715.801 1043.64 -521.062 882.427 -486.511 877.21L-244.457 840.659L-142.488 658.765L-105.832 275.643L62.6903 201.138L140.239 238.485L188.739 382.79C202.405 434.739 227.199 544.964 217.052 570.282C206.904 595.599 232.576 711.639 246.681 766.494L298.652 995.01L328.5 1192.68L294.356 1374.73L216.379 1463.81L-11.8998 1523.55L-274.759 1537.97Z",
    stroke: "#1F232E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2590_13822",
    x: -1155.94,
    y: 0.587646,
    width: 1684.95,
    height: 1820.31,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_2590_13822"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftBg);
export default __webpack_public_path__ + "static/media/left-bg.b54ec9bb4cf672dff89444f37c08e4b0.svg";
export { ForwardRef as ReactComponent };